module.exports = __webpack_public_path__ + "static/images/phone.d7f4e8b75353f9edd53790dcff1c80c2.svg";